import { computed, inject } from '@angular/core';
import { signalStore, type, withComputed, withProps } from '@ngrx/signals';
import { entityConfig, withEntities } from '@ngrx/signals/entities';
import {
  withEntitiesLoadingCall,
  withCallStatus,
  withEntitiesLocalSort,
  withLogger,
} from '@ngrx-traits/signals';
import {
  TextBlockCombinationOption,
  TextBlockCombinationOptionService,
} from '..';
import { map } from 'rxjs';

const textBlockCombinationOptionConfig = entityConfig({
  entity: type<TextBlockCombinationOption>(),
  collection: 'textBlockCombinationOption',
});

export const TextBlockCombinationOptionStore = signalStore(
  withEntities(textBlockCombinationOptionConfig),
  withCallStatus(textBlockCombinationOptionConfig, {
    initialValue: 'loading',
  }),
  withEntitiesLocalSort(
    {
      entity: type<TextBlockCombinationOption>(),
      collection: textBlockCombinationOptionConfig.collection,
    },
    {
      defaultSort: { field: 'name', direction: 'asc' },
    }
  ),
  withLogger({
    name: 'TextBlockCombinationOptionStore',
    showDiff: true,
  }),
  withProps(() => ({
    _textBlockCombinationOptionService: inject(
      TextBlockCombinationOptionService
    ),
  })),
  withEntitiesLoadingCall(({ _textBlockCombinationOptionService }) => ({
    collection: textBlockCombinationOptionConfig.collection,
    fetchEntities: () =>
      _textBlockCombinationOptionService.loadTextBlockCombinations().pipe(
        map((response) => ({
          entities: response.result,
          total: response.count,
        }))
      ),
  })),
  withComputed(({ textBlockCombinationOptionEntities }) => ({
    options: computed(() =>
      textBlockCombinationOptionEntities().map(
        textBlockCombinationOptionToOption
      )
    ),
  }))
);

const textBlockCombinationOptionToOption = (
  textBlockCombination: TextBlockCombinationOption
) => ({
  value: textBlockCombination.id.toString(),
  label: textBlockCombination.name,
  metadata: textBlockCombination,
});
